import { Accordion } from '@/app/components/Accordion/Accordion';
import SectionContainer from '@/app/components/SectionContainer/SectionContainer';

import { useMediaQuery } from '@material-ui/core';

import styles from './PlacementTypeSection.module.scss';
import { LocumContent } from './components/LocumContent';
import { PermanentContent } from './components/PermanentContent';

export const PlacementTypeSection = () => {
  const isDesktop = useMediaQuery('(min-width: 1024px)');

  const titleLocum = (
    <p className={styles.accordionTitle}>
      <span>Locum work?</span>
    </p>
  );

  const titlePermanent = (
    <p className={styles.accordionTitle}>
      <span>Permanent work?</span>
    </p>
  );

  return (
    <SectionContainer className={styles.placementSectionContainer}>
      <h4 className={styles.sectionTitle}>
        Are you <span>interested in...</span>
      </h4>
      <Accordion title={titleLocum} variant="secondary" testId="locum-accordion" top>
        <LocumContent isDesktop={isDesktop} />
      </Accordion>
      <Accordion title={titlePermanent} variant="secondary" testId="permanent-accordion" bottom>
        <PermanentContent isDesktop={isDesktop} />
      </Accordion>
    </SectionContainer>
  );
};
